import Vue from 'vue';
import { MUTATION_REGISTER_SNAPSHOT_LISTENER } from './constants';
import { types as userTypes } from './user';
import {
  set,
  firestoreDocumentByPath,
  onSnapshot,
  firestoreCollection,
} from '../firebase/firestore';

export const VOTE = {
  NONE: 'none',
  UP: 'upvote',
  DOWN: 'downvote',
  QUESTION: 'questionvote',
};

const MODULE_PREFIX = 'votes';

const ACTION_WRITE_VOTE = 'writeVote';
const ACTION_FETCH_VOTES = 'fetchVotes';

const MUTATION_RECEIVED_VOTES = 'receivedVotes';
const MUTATION_RECEIVED_CURRENT_USER_VOTE = 'receivedCurrentUserVote';

const GETTER_VOTES = 'getVotes';
const GETTER_CURRENT_USER_VOTE = 'getCurrentUserVote';

const initialState = {
  votes: {},
  currentUserVotes: {},
};

const actions = {
  [ACTION_FETCH_VOTES]: ({ rootGetters, commit }, path) => {
    const snapshotListener = onSnapshot(
      firestoreCollection(path),
      onVotesSnapshot.bind(this, commit, path, rootGetters[userTypes.getters.userId]),
    );

    commit(
      MUTATION_REGISTER_SNAPSHOT_LISTENER,
      { snapshotListener, id: `votes/${path}` },
      { root: true },
    );
  },
  [ACTION_WRITE_VOTE]: (_, { path, vote }) => {
    set(
      firestoreDocumentByPath(path),
      vote,
    );
  },
};

const onVotesSnapshot = (commit, path, currentUserId, snapshot) => {
  const votes = {
    [VOTE.UP]: 0,
    [VOTE.DOWN]: 0,
    [VOTE.QUESTION]: 0,
  };

  snapshot.docs.forEach(currentVoteRef => {
    const currentVote = currentVoteRef.data();
    if (currentVote.userId === currentUserId) {
      commit(MUTATION_RECEIVED_CURRENT_USER_VOTE, { path, vote: currentVote });
    }
    votes[currentVote.voteType] += 1;
  });

  commit(MUTATION_RECEIVED_VOTES, { path, votes });
};

const mutations = {
  [MUTATION_RECEIVED_VOTES]: (state, { path, votes }) => {
    Vue.set(state.votes, path, votes);
  },
  [MUTATION_RECEIVED_CURRENT_USER_VOTE]: (state, { path, vote }) => {
    Vue.set(state.currentUserVotes, path, vote);
  },
};

const getters = {
  [GETTER_VOTES]: (state) => (votesPath) => state.votes[votesPath],
  [GETTER_CURRENT_USER_VOTE]: (state) => (votesPath) => state.currentUserVotes[votesPath],
};

export default {
  namespaced: true, state: initialState, actions, getters, mutations,
};

export const types = {
  actions: {
    writeVote: `${MODULE_PREFIX}/${ACTION_WRITE_VOTE}`,
    fetchVotes: `${MODULE_PREFIX}/${ACTION_FETCH_VOTES}`,
  },
  getters: {
    votes: `${MODULE_PREFIX}/${GETTER_VOTES}`,
    currentUserVote: `${MODULE_PREFIX}/${GETTER_CURRENT_USER_VOTE}`,
  },
};
